// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.goBackBtn[data-v-0f2daead] {
  background-color: #2C7BBC;
}
.uploadDocumentBtn[data-v-0f2daead] {
  background-color: #4A851F;
}
.uploadDocumentBtn[disabled][data-v-0f2daead] {
  cursor: not-allowed;
}
.btn:disabled.uploadDocumentBtn[data-v-0f2daead] {
  opacity: 0.4;
}
.black-text-color[data-v-0f2daead] {
  color: #000000 !important;
}
.card--upload-document[data-v-0f2daead] {
  min-height: 185px;
}
.card--upload-document p.card-text[data-v-0f2daead] {
  min-height: 80px;
}
.card--upload-document p.card-text.height40[data-v-0f2daead] {
  min-height: 40px;
}
.card--upload-document .card-title[data-v-0f2daead] {
  min-height: 45px;
}
a.link-switchidpal[data-v-0f2daead] {
  float: right;
  text-decoration: underline;
  font-size: medium;
}
a.link-switchidpal[data-v-0f2daead]:before {
  content: "\\f053";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}
.exactCenter[data-v-0f2daead] {
  width: 250px;
  height: 200px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -100px;
  margin-left: -100px;
  z-index: 50000;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/application/document/edit.vue","webpack://./edit.vue"],"names":[],"mappings":"AAEA;EACI,yBAAA;ACDJ;ADIA;EACI,yBAAA;ACFJ;ADKA;EACI,mBAAA;ACHJ;ADMA;EACI,YAAA;ACJJ;ADOA;EACI,yBAAA;ACLJ;ADQA;EACI,iBAAA;ACNJ;ADSA;EACI,gBAAA;ACPJ;ADUA;EACI,gBAAA;ACRJ;ADWA;EACI,gBAAA;ACTJ;ADYA;EACI,YAAA;EACA,0BAAA;EACA,iBAAA;ACVJ;ADaA;EACI,gBAAA;EACA,kCAAA;EACA,gBAAA;ACXJ;ADeA;EACI,YAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;ACbJ","sourcesContent":["\n\n.goBackBtn {\n    background-color: #2C7BBC;\n}\n\n.uploadDocumentBtn {\n    background-color: #4A851F;\n}\n\n.uploadDocumentBtn[disabled] {\n    cursor: not-allowed;\n}\n\n.btn:disabled.uploadDocumentBtn {\n    opacity: .40;\n}\n\n.black-text-color {\n    color: #000000 !important;\n}\n\n.card--upload-document{\n    min-height: 185px;\n}\n\n.card--upload-document p.card-text{\n    min-height: 80px;\n}\n\n.card--upload-document p.card-text.height40{\n    min-height: 40px;\n}\n\n.card--upload-document .card-title{\n    min-height: 45px;\n}\n\na.link-switchidpal{\n    float: right;\n    text-decoration: underline;\n    font-size: medium;\n}\n\na.link-switchidpal:before{\n    content: \"\\f053\";\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n\n}\n\n.exactCenter {\n    width:250px;\n    height:200px;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    margin-top: -100px;\n    margin-left: -100px;\n    z-index: 50000;\n}\n",".goBackBtn {\n  background-color: #2C7BBC;\n}\n.uploadDocumentBtn {\n  background-color: #4A851F;\n}\n.uploadDocumentBtn[disabled] {\n  cursor: not-allowed;\n}\n.btn:disabled.uploadDocumentBtn {\n  opacity: 0.4;\n}\n.black-text-color {\n  color: #000000 !important;\n}\n.card--upload-document {\n  min-height: 185px;\n}\n.card--upload-document p.card-text {\n  min-height: 80px;\n}\n.card--upload-document p.card-text.height40 {\n  min-height: 40px;\n}\n.card--upload-document .card-title {\n  min-height: 45px;\n}\na.link-switchidpal {\n  float: right;\n  text-decoration: underline;\n  font-size: medium;\n}\na.link-switchidpal:before {\n  content: \"\\f053\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 900;\n}\n.exactCenter {\n  width: 250px;\n  height: 200px;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  margin-top: -100px;\n  margin-left: -100px;\n  z-index: 50000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
